/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { FormDefinitionWrapper } from '../../react/components/form/services/form';
import { DBSchema, OpenDBCallbacks } from "idb";
import { DairyFARMDB } from "../store";

export const FORMS_STORE = "forms" as "forms";
export const LAST_FORM_CHECK_KEY = "LAST_FORM_CHECK";

export interface FormStore extends DBSchema {
  [FORMS_STORE]: {
    key: string;
    value: FormDefinitionWrapper;
    indexes: {
      type: string;
      version: number;
      modified: string;
    };
  };
}

export const formStoreConfig: OpenDBCallbacks<DairyFARMDB> = {
  upgrade(db, oldVersion, newVersion, transaction) {
    if (!db.objectStoreNames.contains(FORMS_STORE)) {
      const formStore = db.createObjectStore(FORMS_STORE, {
        keyPath: "id",
      });
      formStore.createIndex("type", "form_id");
      formStore.createIndex("version", "major_version");
      formStore.createIndex("modified", "modified");
    }
  },
};
